import { render, staticRenderFns } from "./ScrollPaginator.vue?vue&type=template&id=2a617c65"
import script from "./ScrollPaginator.vue?vue&type=script&lang=js"
export * from "./ScrollPaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports